var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79982 7.9C3.52982 7.31 2.79982 6.7 2.79982 5.75C2.79982 4.66 3.80982 3.9 5.49982 3.9C7.27982 3.9 7.93982 4.75 7.99982 6H10.2098C10.1398 4.28 9.08982 2.7 6.99982 2.19V0H3.99982V2.16C2.05982 2.58 0.499824 3.84 0.499824 5.77C0.499824 8.08 2.40982 9.23 5.19982 9.9C7.69982 10.5 8.19982 11.38 8.19982 12.31C8.19982 13 7.70982 14.1 5.49982 14.1C3.43982 14.1 2.62982 13.18 2.51982 12H0.319824C0.439824 14.19 2.07982 15.42 3.99982 15.83V18H6.99982V15.85C8.94982 15.48 10.4998 14.35 10.4998 12.3C10.4998 9.46 8.06982 8.49 5.79982 7.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/currency-icon.b46dea33d3905782898e7c68304d2a86.svg";
export { ForwardRef as ReactComponent };